<template>
  <div class="my-1 card">
    <div class="my-0 py-1 card-header text-info">
      <h4 class="my-0 py-1">
        <span>{{this.$store.getters.selectedBusinessType}} Details</span>
      </h4>
    </div>
    <div class="card-body">
      <h4 v-if="sowDetails.SoWWebUrl">
        <span>SoW Generated successfully!</span>
        <a target="_blank" :href="sowDetails.SoWWebUrl">
          <span>View SoW</span>
          </a>
        <a
          target="_blank"
          v-if="sowDetails.MSAWebUrl"
          class="ml-2"
          :href="sowDetails.MSAWebUrl"
        >View MSA</a>
      </h4>
      <h4 v-if="!sowDetails.SoWWebUrl">
        <span>SoW Generation Failed!</span>
      </h4>
      <button class="btn btn-secondary" @click="goback">Generate Again</button>
      <button class="btn btn-info mx-2" @click="gonext">Generate New</button>
      <router-link :to="sowsPath" v-if="sowDetails.SoWWebUrl" para class="text-info">View SoWs</router-link>
    </div>
  </div>
</template>
<script>
import serviceProxy from "../services/index";
import _ from "lodash";
export default {
  name: "generatemdr",
  data() {
    return {
      sowDetails: {},
      sowsPath: "/sows" ///" + this.$store.getters.selectedLawfirm
    };
  },
  created() {
    let that = this;
    that.$root.$emit("progress");
    that.$root.$emit("toast", {
      title: "Creating "+this.$store.getters.selectedBusinessType,
      message: "Knitting everything together to generate the "+ this.$store.getters.selectedBusinessType
    });
    let placeHolderValues = this.$store.getters.placeholderValues;
    let token = this.$store.getters.token;
    let country = that.$store.getters.selectedCountry;
    let MDRData = {};
    MDRData.PlaceHolders = _.map(placeHolderValues, ph => {
      return {
        Name: ph.Slug,
        Value: ph.Value
      };
    });
    MDRData.Token = token;
    MDRData.SoWTemplateFileId = that.$store.getters.selectedMDRTemplateConfig.SoWFileId;
    MDRData.MSATemplateFileId = that.$store.getters.selectedMDRTemplateConfig.MSAFileId;
      MDRData.Type=that.$store.getters.selectedBusinessType;
    serviceProxy.mdr
      .generateMDR(that.$store.getters.token, country, MDRData)
      .then(data => {
        that.sowDetails = data.data;
        that.$root.$emit("done");
        that.$root.$emit("toast", {
          title: this.$store.getters.selectedBusinessType+"Generated",
          message:
            this.$store.getters.selectedBusinessType+" generated for the selected country and the given values"
        });
        //tjat.$store.commit("setCreateAgainMode", true);
        confetti.start();
        setTimeout(function() {
          confetti.stop();
        }, 3000);
      })
      .catch(e => {
        console.log(e);
        that.$root.$emit("done");
      });
  },
  methods: {
    goback: function(oEvent) {
      this.$router.go(-1);
    },
    gonext: function(oEvent) {
      this.$root.$emit("init");
      this.$router.replace({ path: "choose-document" });
    }
  }
};
</script>

<style scoped>
</style>